const externalPage = <HTMLElement>document?.querySelector("#external-site");
const ui = <HTMLElement>document?.querySelector(".ui");

const backButton = document?.querySelector("#external-site-back-button");
const confirmButton = document?.querySelector(".external-site-confirm-button");

const downloadPage = <HTMLElement>document?.querySelector(".download");
export let currentPage = "homepage";

const ExternalLink = () => {
  if (!confirmButton) return;

  confirmButton.addEventListener("click", () => {
    const currentLink = confirmButton.getAttribute("data-href");
    if (currentLink) {
      window.open(currentLink, "_blank");
    }
    confirmButton?.classList.add("active");
  });

  backButton?.addEventListener("click", () => {
    externalPage.style.display = "none";
    ui.style.display = "flex";
    downloadPage.style.display = "none";
    ui.style.display = "flex";
  });
};

export default ExternalLink;
